/**
 * @summary - Component that Provides Add firebase for notification functionality
 * @autor vengateshwaran k
 * @since 2024-06-21
 */
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

  const firebaseConfig = {
    apiKey: "AIzaSyBTZ1EmQzkp6n7fbqeH4SnotjJI42h2pc4",
    authDomain: "ifacx-40695.firebaseapp.com",
    databaseURL: "https://ifacx-40695-default-rtdb.firebaseio.com",
    projectId: "ifacx-40695",
    storageBucket: "ifacx-40695.firebasestorage.app",
    messagingSenderId: "216283128009",
    appId: "1:216283128009:web:3cde59ca0bf82006b16d18",
    measurementId: "G-DRFYM8CF9H"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Messaging
const messaging = getMessaging(app);

export { messaging };
